import '../Sass/App.scss';
import React, { useState, useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress'; 
import {MLDeck} from './MLDeck';

export function MachineLearning(props) {

    const [mlDecks, setMlDecks] = useState([])
    const [vcDecks, setVcDecks] = useState([])
    const [dataLoaded, setDataLoaded] = useState(false)
        
    useEffect(() => {
        fetch("https://www.malwaregame.com/php/ml.php")
            .then((res) => res.json())
            .then((json) => {
                setMlDecks(json.data.ml)
                setVcDecks(json.data.viral)
                setDataLoaded(true)
            })
    }, []) 

    return (
        <>
        <div style={{display: props.inFocus ? 'block' : 'none', width: '100%', float: 'left'}}>
        <div className='white-code'><b>viral</b> functions and listeners</div>
        { dataLoaded && vcDecks.map((deck, index) =>
                <MLDeck deck={deck} index={index} key={index} clickHandler={props.clickHandler} searchHandler={props.searchHandler} type='viral'/>
        )}
        </div>
        <div style={{display: props.inFocus ? 'block' : 'none', width: '100%', float: 'left', marginTop: '20px'}}>
        <div className='white-code'><b>machine learning</b> decks</div>
        { dataLoaded && mlDecks.map((deck, index) =>
                <MLDeck deck={deck} index={index} key={index} clickHandler={props.clickHandler} searchHandler={props.searchHandler} type='ml'/>
        )}
        </div>
        { !(dataLoaded) &&
            <LinearProgress color="success" />
        }
        </>
    )   
}
